import { Spinner } from '@app/components/various/Spinner';
import { cn } from '@app/utils/cn';

interface Props {
  isLoading: boolean;
}

export const LoadMore = ({ isLoading }: Props) => {
  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-2 py-10 text-center opacity-0 transition-opacity', {
        'opacity-100': isLoading,
      })}
    >
      <Spinner className="h-8 w-8" />
    </div>
  );
};
